import Container from '@mui/material/Container';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-premium';
import { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Table } from '../../components/Table';
import { TableRef } from '../../components/Table/Table';
import { fetchStatuses } from '../../constants/fetchStatuses';
import { useSearchParamsState } from '../../hooks';
import { fetchPromoCodeUsages } from '../../redux/modules/prompCodes/promoCode.actions';
import { promoCodeSelector } from '../../redux/modules/prompCodes/promoCode.selectors';
import { parseJSON } from '../../utils/json';

export function PromoCodeUsages() {
  const tableRef = useRef<TableRef>(null);
  const { id } = useParams();
  const [columns] = useState<GridColDef[]>([
    {
      field: 'id',
      headerName: 'Id',
      width: 80,
    },
    {
      field: 'user.fullName',
      headerName: 'Name',
      flex: 1,
      valueGetter: (params) => params.row?.user?.fullName,
    },
    {
      field: 'user.email',
      headerName: 'Email',
      flex: 1,
      valueGetter: (params) => params.row?.user?.email,
    },
    {
      field: 'user.mobile',
      headerName: 'Phone number',
      flex: 1,
      // eslint-disable-next-line no-console
      valueGetter: (params) => params.row?.user?.mobile,
    },
    {
      field: 'user.nationalIdNumber',
      headerName: 'National Id',
      flex: 1,
      valueGetter: (params) => params.row?.user?.nationalIdNumber || '-',
    },
    {
      field: 'referralCode.name',
      headerName: 'Code Name',
      flex: 1,
      valueGetter: (params) => params.row?.referralCode?.name || '-',
    },
    {
      field: 'referralCode.code',
      headerName: 'Code',
      flex: 1,
      valueGetter: (params) => params.row?.referralCode?.code || '-',
    },
    {
      field: 'createdAt',
      headerName: 'Created',
      type: 'date',
      minWidth: 100,
      renderCell: (params: GridRenderCellParams) => {
        if (!params.value) {
          return '';
        }
        return params.formattedValue;
      },
    },
  ]);
  const [initialFilterModel, setInitialFilterModel] = useSearchParamsState('filter', '');
  const [initialPage, setInitialPage] = useSearchParamsState('page', '0');
  const [initialPageSize, setInitialPageSize] = useSearchParamsState('pageSize', '100');

  const { totalPromoCodeUsages, promoCodeUsages, fetchStatus } = useSelector(promoCodeSelector);
  const isLoading = fetchStatus === fetchStatuses.pending;

  return (
    <Container component="main" maxWidth="xl">
      <Table
        ref={tableRef}
        fetchItems={fetchPromoCodeUsages}
        fetchItemsCustomParams={{ id }}
        rows={promoCodeUsages}
        columns={columns}
        loading={isLoading}
        rowCount={totalPromoCodeUsages}
        initialFilterModel={parseJSON(initialFilterModel)}
        initialPage={+initialPage}
        initialPageSize={+initialPageSize}
        onFilterModelChange={(filterModel) => setInitialFilterModel(JSON.stringify(filterModel))}
        onPageChange={(page) => setInitialPage(`${page}`)}
        onPageSizeChange={(pageSize) => setInitialPageSize(`${pageSize}`)}
      />
    </Container>
  );
}
